module.exports = __webpack_public_path__ + "static/media/essential-oils-made-easy.b6ef72de.pdf";